import {DynamicDataTableFilter, FilterSettings} from "./types";

export function buildUrlWithFilterParams<T>(filters: FilterSettings<T>): string {
  return '?' + Object.entries(filters).map(([key, value]) => `${key}=${value}`).join('&')
}

export function getDefaultFilterValues<T>(searchParams: URLSearchParams, filters: DynamicDataTableFilter<T>[], filterProperty: keyof T | string) {
  const filter = filters.find(f => f.property === filterProperty)
  return searchParams.get(filterProperty.toString()) ?? filter?.defaultValue
}